var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2630,
    height: 1767,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-885 -363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 363,
    width: 2630,
    height: 1767,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2971.34 1255.22C3172.9 1742.48 2762.58 2049.92 2268.12 2049.92 1773.66 2049.92 1372.79 1694.14 1372.79 1255.22 1372.79 816.295 1771.56 423.918 2265.99 423.918 2760.42 423.918 2939.69 629.222 2971.34 1255.22",
    fill: "#EBF2FC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280.65 667.865C2278.56 654.366 2275.77 633.902 2275.77 621.307 2342.59 393.715 1954.05 322.984 1956.4 597.722 1940.73 619.792 1928.6 639.509 1921.13 652.263 1916.17 660.742 1918.41 671.551 1926.31 677.407L1954.98 698.663C1957.45 700.494 1959.31 703.05 1960.31 705.967L1981.79 769.348C1985.73 781.016 1996.53 789.044 2008.89 789.496L2172.11 795.488C2177.85 795.692 2183.36 793.34 2187.17 789.066 2187.17 789.066 2211.92 735.679 2273.57 691.925 2280.74 686.837 2282.01 676.548 2280.67 667.865Z",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2499.9 955.774C2499.9 868.575 2309.6 685.299 2284.78 695.944 2138.68 732.296 2040.1 1186.09 2061.39 1242.78 2091.78 1253.25 2471.61 1238.66 2557.26 1235.22 2566.06 1234.85 2572.27 1226.47 2570.05 1217.96L2517.62 1016",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1993.5 786.5C1993.5 786.5 1938.43 971.995 1913.86 1033.14 1906.98 1050.24 1881.26 1096.89 1868.43 1121.95 1862.57 1133.4 1870.76 1147.04 1883.63 1147.24L1966.46 1150.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077.5 792.5C2077.5 792.5 1954.02 1084.04 1957.58 1257.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1951.58 1321.74 1946.26 1499.42 1915.82 1588.58C1914.28 1594.08 1918.43 1599.5 1924.13 1599.5L2479.17 1595C2486.66 1594.93 2492.38 1588.33 2491.39 1580.94L2445.45 1241.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2209.5 1239.5C2209.5 1239.5 2220.13 955.335 2334.5 838.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2457.5 1334.5 2269.59 1344.58C2246 1345.84 2227.5 1365.3 2227.5 1388.87L2227.5 1450.02C2227.5 1483.69 2255.5 1510.64 2289.25 1509.46L2289.25 1509.46C2340.16 1507.68 2353.12 1463.26 2366.58 1416.18L2386.73 1341.4",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2264.5 1344.5 2262.5 1247.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2386.5 1596.5 2354.57 1944.97 2100.5 1948.5 2102.31 1931.11C2104.54 1909.72 2116.53 1890.54 2134.81 1879.12L2257.01 1808.75",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.59 1601.5C2021.59 1601.5 2035.62 1706.25 2090.85 1801.24 2095.81 1809.78 2093.64 1820.7 2085.78 1826.68L1970.53 1889.53C1956.38 1897.25 1948.18 1912.66 1949.67 1928.72L1952.5 1947.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2437.96 2052.96 1555.5 2056.5 1867.42 1950.06 2432.64 1946.5 2845.5 2045.86 2517.7 2049.4",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2147.5 1597.5C2147.5 1597.5 2145.73 1806.64 2363.5 1854.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2241.5 1600.5C2241.5 1600.5 2266.24 1707.36 2370.5 1721.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2127.78 569.5C2196.21 569.5 2208.18 655.577 2126.5 660.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2038.5 582.122 1964.54 580.5C1961.7 580.455 1960.4 584.014 1962.63 585.771L2006.43 615.5",
    stroke: "#1930AB",
    strokeWidth: 20.625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e9ac9294a5ab4148c662272a4d72ee2f.svg";
export { ForwardRef as ReactComponent };